import React from 'react';
import { ThreeDots } from "react-loader-spinner";

export default function LoadingSpinner() {
  return (
    <div className="access-control-loading">
      <ThreeDots color="#262626" height={80} width={80} />
    </div>
  );
} 